import React, { useState, useEffect, useCallback } from 'react';

// CRM 계정관리 (2026-07-27 신설)
// ants_usermaster 대상. 생성/수정/비번변경/승인·차단/삭제.
// 비번은 목록에 표시하지 않고, 서버 admin API가 자동 암호화·use_yn 자동·삭제 실행수 확인.
// 상대경로 fetch → domainFetch 래퍼가 X-Domain(창별 도메인) 자동 부착.

const API = '/request/admin';

export default function AccountManagement() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ user_id: '', user_pwd: '', user_name: '', email_address: '', user_mobile: '' });
  const [pwTarget, setPwTarget] = useState(null); // 비번변경 대상 user
  const [pwValue, setPwValue] = useState('');

  const load = useCallback(async () => {
    setLoading(true); setErr('');
    try {
      const r = await fetch(`${API}/listUsers`, { credentials: 'include' });
      const d = await r.json();
      if (!r.ok || !d.ok) throw new Error(d.error || '목록을 불러오지 못했습니다.');
      setUsers(d.users || []);
    } catch (e) { setErr(e.message); setUsers([]); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const post = async (path, body) => {
    const r = await fetch(`${API}/${path}`, {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    let d = {};
    try { d = await r.json(); } catch (e) {}
    if (!r.ok || !d.ok) throw new Error(d.error || '요청이 실패했습니다.');
    return d;
  };

  const onCreate = async () => {
    if (!form.user_id.trim() || !form.user_pwd) { alert('아이디와 비밀번호는 필수입니다.'); return; }
    try {
      await post('createUser', form);
      alert('계정이 생성되었습니다. 바로 로그인할 수 있습니다.');
      setShowAdd(false);
      setForm({ user_id: '', user_pwd: '', user_name: '', email_address: '', user_mobile: '' });
      load();
    } catch (e) { alert('생성 실패: ' + e.message); }
  };

  const onApprove = async (u, useYn) => {
    try { await post('approveUser', { id: u.id, use_yn: useYn }); load(); }
    catch (e) { alert('변경 실패: ' + e.message); }
  };

  const onDelete = async (u) => {
    if (!window.confirm(`계정 '${u.user_id}'를 삭제하시겠습니까? 되돌릴 수 없습니다.`)) return;
    try {
      await post('deleteUser', { id: u.id, user_id: u.user_id });
      alert('삭제되었습니다.');
      load();
    } catch (e) { alert('삭제 실패: ' + e.message); }
  };

  const onChangePw = async () => {
    if (!pwValue) { alert('새 비밀번호를 입력하세요.'); return; }
    try {
      await post('changePassword', { id: pwTarget.id, new_password: pwValue });
      alert(`'${pwTarget.user_id}' 비밀번호가 변경되었습니다.`);
      setPwTarget(null); setPwValue('');
    } catch (e) { alert('변경 실패: ' + e.message); }
  };

  const th = { textAlign: 'left', padding: '8px 10px', fontSize: 12, color: '#555', borderBottom: '2px solid #e5e5e5', whiteSpace: 'nowrap' };
  const td = { padding: '7px 10px', borderBottom: '1px solid #eee', fontSize: 13 };
  const btn = (bg) => ({ padding: '4px 10px', margin: '0 2px', borderRadius: 5, border: 0, background: bg, color: '#fff', fontSize: 12, cursor: 'pointer' });
  const inp = { padding: 7, borderRadius: 6, border: '1px solid #ccc', fontSize: 13, width: '100%', boxSizing: 'border-box' };

  return (
    <div style={{ padding: 24, width: '100%', maxWidth: 1100 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <h2 style={{ margin: 0 }}>계정관리</h2>
        <button onClick={() => setShowAdd(v => !v)} style={btn('#1976d2')}>+ 계정 추가</button>
      </div>
      <p style={{ color: '#777', fontSize: 13, margin: '0 0 16px' }}>
        CRM 접속 계정을 생성·수정·삭제하고 비밀번호 변경, 승인/차단을 관리합니다. 생성 즉시 로그인 가능(자동 승인).
      </p>

      {showAdd && (
        <div style={{ border: '1px solid #cfe0f5', background: '#f3f8ff', borderRadius: 10, padding: 16, marginBottom: 18 }}>
          <div style={{ fontWeight: 700, marginBottom: 10, color: '#1565c0' }}>새 계정 추가</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 10, maxWidth: 640 }}>
            <input style={inp} placeholder="아이디*" value={form.user_id} onChange={e => setForm({ ...form, user_id: e.target.value })} />
            <input style={inp} placeholder="비밀번호*" type="password" value={form.user_pwd} onChange={e => setForm({ ...form, user_pwd: e.target.value })} />
            <input style={inp} placeholder="이름" value={form.user_name} onChange={e => setForm({ ...form, user_name: e.target.value })} />
            <input style={inp} placeholder="이메일" value={form.email_address} onChange={e => setForm({ ...form, email_address: e.target.value })} />
            <input style={inp} placeholder="휴대폰" value={form.user_mobile} onChange={e => setForm({ ...form, user_mobile: e.target.value })} />
          </div>
          <div style={{ marginTop: 12 }}>
            <button onClick={onCreate} style={btn('#1976d2')}>생성</button>
            <button onClick={() => setShowAdd(false)} style={btn('#888')}>취소</button>
          </div>
        </div>
      )}

      {err && <div style={{ color: '#c62828', marginBottom: 10, fontSize: 13 }}>{err}</div>}

      <div style={{ overflowX: 'auto', border: '1px solid #e5e5e5', borderRadius: 10 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>
            <th style={th}>아이디</th><th style={th}>이름</th><th style={th}>이메일</th>
            <th style={th}>휴대폰</th><th style={th}>승인</th><th style={th}>생성일</th>
            <th style={{ ...th, textAlign: 'center' }}>관리</th>
          </tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td style={{ ...td, fontWeight: 700 }}>{u.user_id}</td>
                <td style={td}>{u.user_name || '-'}</td>
                <td style={td}>{u.email_address || '-'}</td>
                <td style={td}>{u.user_mobile || '-'}</td>
                <td style={td}>
                  {u.use_yn === 'Y'
                    ? <span style={{ color: '#16a34a', fontWeight: 700 }}>승인</span>
                    : <span style={{ color: '#dc2626', fontWeight: 700 }}>차단</span>}
                </td>
                <td style={{ ...td, color: '#999', fontSize: 12 }}>{u.created_at || '-'}</td>
                <td style={{ ...td, textAlign: 'center', whiteSpace: 'nowrap' }}>
                  <button onClick={() => { setPwTarget(u); setPwValue(''); }} style={btn('#6b7280')}>비번변경</button>
                  {u.use_yn === 'Y'
                    ? <button onClick={() => onApprove(u, 'N')} style={btn('#d97706')}>차단</button>
                    : <button onClick={() => onApprove(u, 'Y')} style={btn('#16a34a')}>승인</button>}
                  <button onClick={() => onDelete(u)} style={btn('#dc2626')}>삭제</button>
                </td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 20, textAlign: 'center', color: '#999' }}>{loading ? '불러오는 중…' : '계정이 없습니다'}</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {pwTarget && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 10, padding: 24, width: 340 }}>
            <div style={{ fontWeight: 700, marginBottom: 12 }}>'{pwTarget.user_id}' 비밀번호 변경</div>
            <input style={inp} type="password" placeholder="새 비밀번호" value={pwValue} onChange={e => setPwValue(e.target.value)} autoFocus />
            <div style={{ marginTop: 14, textAlign: 'right' }}>
              <button onClick={onChangePw} style={btn('#1976d2')}>변경</button>
              <button onClick={() => setPwTarget(null)} style={btn('#888')}>취소</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
